import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const TRASH_PATH_D =
  'M11.4999 6.5V7.33333H7.33325V9H8.16659V19.8333C8.16659 20.2754 8.34218 20.6993 8.65474 21.0118C8.9673 21.3244 9.39122 21.5 9.83325 21.5H18.1666C18.6086 21.5 19.0325 21.3244 19.3451 21.0118C19.6577 20.6993 19.8333 20.2754 19.8333 19.8333V9H20.6666V7.33333H16.4999V6.5H11.4999ZM9.83325 9H18.1666V19.8333H9.83325V9ZM11.4999 10.6667V18.1667H13.1666V10.6667H11.4999ZM14.8333 10.6667V18.1667H16.4999V10.6667H14.8333Z';

const TrashcanIcon = ({ width = 28, height = 28, color = '#B23E3E' }) => (
  <SvgIcon
    viewBox="0 0 28 28"
    fill="none"
    sx={{
      width,
      height,
      borderRadius: '4px',
      opacity: 1,
      color,
      '& > rect[data-trash-hover-bg]': {
        opacity: 0,
        transition: 'opacity 120ms ease-in-out',
      },
      // IconButton padding is outside the svg; hover the full hit target, not only the svg.
      '.MuiIconButton-root:hover & > rect[data-trash-hover-bg], &:hover > rect[data-trash-hover-bg]':
        {
          opacity: 1,
        },
    }}
  >
    <rect data-trash-hover-bg width="28" height="28" rx="4" fill="#FFF2F2" />
    <path d={TRASH_PATH_D} fill="currentColor" />
  </SvgIcon>
);

TrashcanIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default TrashcanIcon;
